import { useEffect } from "react";

export const useOutsideClickHandler = (
  refs,
  onOutsideClick,
  whitelist
) => {
  useEffect(() => {
    function handleClickOutside(event) {
      const refsArray = Array.isArray(refs) ? refs : [refs];

      const isClickedInsideRefs = refsArray.some(
        (ref) => ref.current && ref.current.contains(event.target)
      );

      const isClickedOnWhitelisted = whitelist?.includes(event.target?.id);

      if (!isClickedInsideRefs && !isClickedOnWhitelisted) {
        onOutsideClick();
      }
    }

    window?.addEventListener("mousedown", handleClickOutside);
    return () => {
      window?.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onOutsideClick, refs, whitelist]);
};
